interface PropsType {
  style?: React.CSSProperties;
  color?: string;
}

const CheckIcon = (props: PropsType) => {
  return (
    <svg width="13" height="11" viewBox="0 0 13 11" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M1 5.30769L5.8125 9L12 1" stroke="#E60012" strokeWidth="2" strokeLinecap="round" />
    </svg>
  );
};

export default CheckIcon;
